export default "__VITE_ASSET__BO96968P__"